import React, { useEffect, useRef, useState } from 'react';
import artwork from '../../assets/mobile-server-2selection.png';
import logo from '../../assets/pknin-logo.png';
import accountIcon from '../../assets/ninja-account-center.png';
import { MobileAuthEffects } from './MobileAuthEffects';
import { postData } from '../../util/fetch';
import { API_URL } from '../../util/networkEndpoints';
import { enterMobileFullscreen } from '../../util/mobileFullscreen';
import { rememberUserCenter } from '../../util/userCenterSession';
import { useAppDispatch } from '../../hooks';
import { setServerId } from '../../slices/accountSlice';
import { switchState } from '../../slices/stateSlice';
import { SiteState } from '../../enums';
import './MobileServerSelect.css';

async function request(url: string, payload: any) {
  let timer: ReturnType<typeof setTimeout>;
  try {
    return await Promise.race([postData(url,payload),new Promise<never>((_,reject)=>{timer=setTimeout(()=>reject(new Error('เชื่อมต่อไม่สำเร็จ กรุณาลองอีกครั้ง')),15000);})]);
  } finally { clearTimeout(timer!); }
}

export function MobileServerSelect({jwt,servers,onUserCenter}:{jwt:string;servers:number[];onUserCenter:()=>void}) {
  const dispatch=useAppDispatch();
  const [open,setOpen]=useState<boolean|null>(null);
  const [selected,setSelected]=useState(1),[catalog,setCatalog]=useState<{id:number;open:boolean}[]>([]);
  const chosenOpen=selected===1?open:catalog.find(row=>row.id===selected)?.open===true;
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  const pending=useRef(false), mounted=useRef(true);
  useEffect(()=>{
    mounted.current=true;
    request(`${API_URL}/user-center/profile`,{jwt}).then(result=>{
      if(!mounted.current)return;
      if(result.error)throw new Error(result.error);
      setOpen(result.server?.open===true && servers.includes(1));
      setCatalog(result.servers??[{id:1,open:result.server?.open===true}]);
    }).catch(err=>{if(mounted.current){setOpen(false);setError(err.message);}});
    return()=>{mounted.current=false;};
  },[jwt,servers]);
  async function enter(){
    if(pending.current||chosenOpen!==true)return;
    pending.current=true;setBusy(true);setError('');
    void enterMobileFullscreen();
    try {
      const result=await request(`${API_URL}/selectServer`,{jwt,server:selected});
      if(!mounted.current)return;
      if(result.error||!result.jwt)throw new Error(result.error||'ไม่สามารถเข้าเซิร์ฟเวอร์ได้');
      localStorage.setItem('jwt',result.jwt);rememberUserCenter(jwt);
      dispatch(setServerId(selected));dispatch(switchState(SiteState.GAME_LOADER));
    }catch(err){if(mounted.current){setError((err as Error).message);setBusy(false);}pending.current=false;}
  }
  return <div className="ninja-auth mobile-game-auth mobile-server-select" role="region" aria-label="เลือกเซิร์ฟเวอร์">
    <div className="mobile-server-stage">
      <img className="mobile-server-art" src={artwork} alt="เลือกเซิร์ฟเวอร์ PkNiN" draggable={false}/>
      <img className="mobile-server-logo" src={logo} alt="PkNiN"/>
      <MobileAuthEffects/>
      <button type="button" className="mobile-server-usercenter" aria-label="USERCENTA · เปิด UserCenter" onClick={onUserCenter} disabled={busy}><img src={accountIcon} alt="ศูนย์จัดการบัญชี"/></button>
      <button type="button" className="mobile-server-choice" aria-label="เซิร์ฟเวอร์ 1 แผ่นดินใหญ่" aria-pressed={selected===1} disabled={busy||open!==true} onClick={()=>{setSelected(1);setError('');}}/>
      {catalog.some(row=>row.id===2)&&<button type="button" className="mobile-server-choice-two" aria-label="เซิร์ฟเวอร์ 2 เริ่มต้นใหม่" aria-pressed={selected===2} disabled={busy||!catalog.find(row=>row.id===2)?.open} onClick={()=>{setSelected(2);setError('');}}></button>}
      {chosenOpen!==true&&<span className="mobile-server-status">{chosenOpen===null?'กำลังตรวจสอบ…':'● ปิดปรับปรุง'}</span>}
      <button type="button" className="mobile-server-enter" aria-label={busy?'กำลังเข้าเกม…':'เข้าเกม'} onClick={enter} disabled={busy||chosenOpen!==true}>{busy&&<span>กำลังเข้าเกม…</span>}</button>
      {error&&<div className="mobile-server-error" role="alert">{error}<button type="button" onClick={onUserCenter}>ไปที่ UserCenter</button></div>}
    </div>
  </div>;
}
